import axiosInstance from "../Api/AxiosInstance";
import { redirectHomeOnForbidden } from "./AdminAccessDeniedHelper";

const API_BASE_URL = `${process.env.REACT_APP_SERVICE_URL}`;

export const getGrowthFiscalYearList = async () => {
  const response = await axiosInstance.get(
    `${API_BASE_URL}/GrowthFiscalYearList`
  );

  return response.data;
};

export const getShareholderListForLeader = async (token: string | null, fiscalYearId: string, userId: string) => {
    try {

        const response = await axiosInstance.get(`${API_BASE_URL}/ShareholderListforLeader?fiscalYearId=${fiscalYearId}&userId=${userId}`);

        return response.data;
    }
    catch (error) {
        console.error('Error fetching Shareholder list:', error);
        throw error;
    }
};

export interface GrowthUserDetail {
  apexUserId: string;
  entraObjectId: string;
  role: string;
  leaderName: string;
  leadershipType: "Leader" | "CoLeader";
  fiscalYearId: string;
  name: string;
  email: string;
}

export const getGrowthUserDetailsForLeader = async (
  apexUserId: string,
  fiscalYearId: string
): Promise<GrowthUserDetail> => {
  const response = await axiosInstance.get(
    `${API_BASE_URL}/growth-reportees/${apexUserId}/${fiscalYearId}`
  );

  return response.data;
};

export interface GrowthPersonalLeader {
  leaderName: string;
  leaderEntraObjectId: string;
  fiscalYearId: string;
}

export const getGrowthPersonalLeader = async (
  fiscalYearId: string,
): Promise<GrowthPersonalLeader> => {
  const response = await axiosInstance.get(
    `${API_BASE_URL}/growth-personal-leader/${fiscalYearId}`,
  );

  return response.data;
};

export const getLeadershipCoverageDetails = async (filters: {
  leaderIds: string[];
  fiscalYearIds: string[];
}) => {
  try {
    const response = await axiosInstance.post(
      `${API_BASE_URL}/LeadershipCoverageDetails`,
      filters
    );
    return response.data;
  } catch (error) {
    redirectHomeOnForbidden(error);
    console.error("Error fetching leadership coverage details:", error);
    throw error;
  }
};
